import { API } from "@swivl-mono/api-helper";
import { formatWeeklyPeriods } from "@swivl-mono/helpers";
import { ScheduleSlug } from "@swivl-mono/types";
import { useEffect, useState } from "react";

import { Member } from "../Models/Member/Member.Current";

export interface UseResolvedScheduleTextResult {
  /**
   * Compact weekly-hours text from the resolved structured Schedule (e.g.
   * "Mon-Fri: 9:00 AM - 5:30 PM, Sun: closed"). Null while loading, when no
   * schedule resolves for the location, or on fetch failure.
   */
  text: string | null;
}

/**
 * Resolve a location's structured Schedule (org > group > location cascade,
 * server-side) and format it for display. Replaces reads of the legacy
 * freeform OfficeHours / AccessHours vars, which v3 PM no longer edits
 * (ENG-2723 Cortex-only sweep).
 */
export function useResolvedScheduleText(locationId: number | undefined, slug: ScheduleSlug): UseResolvedScheduleTextResult {
  const [text, setText] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    setText(null);
    const orgId = Member.orgId;
    if (!locationId || !orgId) return;
    API.Schedule.resolve(orgId, locationId, slug)
      .then((resolved) => {
        if (!cancelled) {
          setText(resolved ? formatWeeklyPeriods(resolved.schedule.weekly) : null);
        }
      })
      .catch(() => {
        // Optional enrichment — the card renders without hours on failure.
        if (!cancelled) setText(null);
      });
    return () => {
      cancelled = true;
    };
  }, [locationId, slug]);

  return { text };
}
